import { Action } from "@ngrx/store";

import * as M from "../../data/model";

export type Actions =
    | ReplaceDatabaseAction
    | AddAction
    | DeleteAction
    | UpdateAction
    | MergeAction;

export class ReplaceDatabaseAction implements Action {
    static readonly type = "model/replace-database";
    readonly type = ReplaceDatabaseAction.type;

    constructor(public cp: M.ConsultationProcess) {}
}

export class AddAction implements Action {
    static readonly type = "model/add";
    readonly type = AddAction.type;

    constructor(
        public collection: any,
        public entity: any,
    ) {}
}

export class DeleteAction implements Action {
    static readonly type = "model/delete";
    readonly type = DeleteAction.type;

    constructor(public entity: any) {}
}

export class UpdateAction implements Action {
    static readonly type = "model/update";
    readonly type = UpdateAction.type;

    constructor(public entity: any) {}
}

export class MergeAction implements Action {
    static readonly type = "model/merge";
    readonly type = MergeAction.type;

    constructor(
        public path: string[],
        public diff: any,
    ) {}
}
